module.exports = __webpack_public_path__ + "static/img/no-auth.214ce16.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/no-auth.png
// module id = 81Gd
// module chunks = 4